<cc-casino-page-container
    *ngIf="isLobbyLoaded"
    [lobbyType]="lobbyType"
    [categoryRoute]="categoryRoute"
    [gameContainer]="gameContainer"
    [seeAllProductLinkOverride]="seeAllProductLinkOverride">
</cc-casino-page-container>
<cc-new-game-quick-info *ngIf="isLobbyLoaded && isNewQuickInfoEnabled"></cc-new-game-quick-info>
